import React from "react";

const ExpandingQuantityInput: React.FC<{
  quantity: number;
  setQuantity: (quantity: number) => void;
}> = ({ quantity, setQuantity }) => (
  <input
    min={0}
    type="number"
    className="expanding-quantity-input"
    style={{
      border: "none",
      padding: "none",
      width: "35px",
      background: "none",
      textAlign: "center",
    }}
    value={quantity}
    onChange={(e) => setQuantity(+e.target.value)}
  />
);

export default ExpandingQuantityInput;
